import React, { useEffect, useState } from "react";
import images from "../../../Utils/importImages";
import "./UserSideBar.css";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  getLocalStorageJSON,
  removeLocalStorageJSON,
} from "../../../Utils/localStorageFunc";
import {
  setisAdminLogin,
  setisUserLogin,
  setUserLoggedInData,
} from "../../../Redux/Slices/User_Slices/User-SLICE";
import { LogoutUser } from "../../../Redux/Apis/User-Apis";
import { useLocation, useNavigate } from "react-router-dom";

function UserSideBar({ activeBar, setActiveBar }) {
  let dispatch = useDispatch();

  const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
    (state) => state.user
  );

  console.log("userLoggedInData is : ", userLoggedInData);

  let navigate = useNavigate();

  let logoutFunc = async () => {
    let token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
    let resp = await LogoutUser(
      `${isUserLogin ? "users" : "admins"}/logout`,
      token
    );

    if (resp.error == false) {
      dispatch(setUserLoggedInData(null));
      removeLocalStorageJSON("AL");
      removeLocalStorageJSON("UL");
      dispatch(setisUserLogin(false));
      dispatch(setisAdminLogin(false));
      navigate("/");
    }
  };

  let onClickLogout = () => {
    Swal.fire({
      title: "Do You Really Want To Logout ?",
      showCancelButton: true,
      confirmButtonText: "Yes Logout",
    }).then((result) => {
      if (result.isConfirmed) {
        logoutFunc();
      }
    });
  };

  let getTwoLetterName = () => {
    let name =
      isUserLogin == true
        ? `${userLoggedInData?.user_data?.[0]?.first_name} ${
            userLoggedInData?.user_data?.[0]?.last_name == null
              ? ""
              : userLoggedInData?.user_data?.[0]?.last_name
          }`
        : userLoggedInData?.fullName;

    let splitted = name.split(" ");

    let returnName = splitted.map((item) => item.charAt(0));

    return returnName;
  };

  let getName = () => {
    let name =
      isUserLogin == true
        ? `${userLoggedInData?.user_data?.[0]?.first_name} ${
            userLoggedInData?.user_data?.[0]?.last_name == null
              ? ""
              : userLoggedInData?.user_data?.[0]?.last_name
          }`
        : userLoggedInData?.fullName;
    return name;
  };

  let getContactInfo = () => {
    let credential =
      isUserLogin == true
        ? userLoggedInData?.auth_prime == "email"
          ? userLoggedInData?.email
          : userLoggedInData?.phone
        : userLoggedInData?.email;
    return credential;
  };

  let [BarList, setBarList] = useState([]);

  useEffect(() => {
    if (isUserLogin == true) {
      setBarList([
        {
          name: "My Profile",
          img: "Symbols.svg",
          route: "myprofile",
        },
        {
          name: "Manage Login",
          img: "userdb-aside-managelogin.svg",
          route: "managelogin",
        },
        {
          name: "My Travellers",
          img: "userdb-aside-addtraveller.svg",
          route: "mytravellers",
        },
        {
          name: "My Flight Bookings",
          img: "userdb-aside-flightbooking.svg",
          route: "myflightbookings",
        },
        {
          name: "My Hotel Bookings",
          img: "userdb-aside-myhotelbooking.svg",
          route: "myhotelbookings",
        },
        {
          name: "My Wallet",
          img: "userdb-aside-mywallet.svg",
          route: "mywallet",
        },
        {
          name: "Pending Payments",
          img: "userdb-aside-pendingpayment.svg",
          route: "mypendingpayments",
        },
        { name: "Settings", img: "userdb-aside-settings.svg" },
        { name: "Logout", img: "userdb-aside-logout.svg" },
      ]);
    }

    if (isAdminLogin == true) {
      setBarList([
        {
          name: "My Travellers",
          img: "userdb-aside-addtraveller.svg",
          route: "mytravellers",
        },

        { name: "Logout", img: "userdb-aside-logout.svg" },
      ]);
    
    }
  }, [isUserLogin, isAdminLogin]);

  const location = useLocation();

  return (
    <aside className="userdb-aside">
      <div className="userdb-logged-user">
        <div className="userdb-username-tag">{getTwoLetterName()}</div>
        <div className="userdb-username-info">
          <div className="userdb-uname">{getName()}</div>
          <div className="userdb-email">{getContactInfo()}</div>
        </div>
      </div>
      <ul className="userdb-left-panel">
        {BarList?.map((item, id) => {
          if (item.name != undefined)
            return (
              <li
                className={
                  location.pathname.includes(`/user/${item.route}`)
                    ? "active-userdbtab"
                    : ""
                }
                key={id}
                onClick={() => {
                  if (item.name === "Logout") return onClickLogout();
                  navigate(`/user/${item.route}`);
                }}
              >
                <div className="userdbtab-img">
                  <img src={images[item.img]} alt="" />
                </div>
                {item.name}
              </li>
            );
        })}
      </ul>
    </aside>
  );
}

export default UserSideBar;
